// Central business configuration — edit here to update site-wide info.
export const SITE = {
  name: "CA HVAC Direct",
  fullName: "California HVAC Direct",
  tagline: "HVAC Equipment Direct",
  description:
    "Shop HVAC equipment direct from established manufacturers — ductless mini-split & VRF systems, packaged heat pumps, air handlers and more.",
  
phone: "(909) 568-7316",
phoneHref: "tel:+19095687316",
email: "admincahvacdirect@gmail.com",
emailHref: "mailto:admincahvacdirect@gmail.com",

  hours: null, // Not confirmed yet — leave null to show an editable placeholder.
  address: null, // Not provided yet.
  depositAmount: 500,
  social: {
    // Add real profile URLs when available; null hides / disables the link.
    facebook: null,
    instagram: null,
    youtube: null,
  },
  // Payment architecture — flip `enabled` flags on individually when a real
  // payment processor is connected. Nothing is charged while enabled=false.
  payments: {
    enabled: false,
    methods: [
      { id: "full", label: "Pay full amount online", enabled: false },
      { id: "deposit", label: "$500 deposit / reservation", enabled: false },
      { id: "in-person", label: "Pay in person", enabled: false },
    ],
  },
};
